import React  from 'react'
import TextReadWidget, { TextReadWidgetProps } from './TextWidget'

interface DropdownOption {
    value: string | number
    label?: string
}

interface DropdownReadWidgetProps extends Omit<TextReadWidgetProps, 'value'> {
    value?: string | number | (string | number)[]
    options?: DropdownOption[]
}

const DropdownReadWidget: React.FC<DropdownReadWidgetProps> = ({
    value,
    options,
    ...otherProps
}) => {

    // Handle both single value and array of values
    const displayValue = React.useMemo(() => {
        if (!value) {
            return 'None Selected'
        }

        if (Array.isArray(value)) {
            // Handle multiple selected values
            const selectedLabels = value
                .map(v => options?.find(opt => opt.value === v)?.label)
                .filter(label => label !== undefined)

            return selectedLabels.length > 0
                ? selectedLabels.join(', ')
                : null
        } else {
            // Handle single selected value
            const option = options?.find(opt => opt.value === value)
            return option?.label || null
        }
    }, [value, options])

    return (
        <TextReadWidget
            value={displayValue ?? undefined}
            {...otherProps}
        />
    )
}

export default DropdownReadWidget
